import { IntlProvider } from 'react-intl';
import { translationMessages, DEFAULT_LOCALE } from '../../i18n';

const intlProvider = new IntlProvider({ locale: DEFAULT_LOCALE, messages: translationMessages[DEFAULT_LOCALE] });

// export intl
export const { intl } = intlProvider.getChildContext();
